/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

export type InterventionStatus = typeof InterventionStatus[keyof typeof InterventionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterventionStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  AVAILABLE: 'AVAILABLE',
} as const;
